'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.remoteChecklogin = exports.logout = exports.closeDialog = exports.login = exports.getUserInfo = exports.isLogin = exports.isReal = exports.event = exports.EVENTNAMES = exports.uuid = exports.LOGINURL = void 0;
var _base = require('../base');
function asyncGeneratorStep(e, o, n, t, r, i, a) {
    try {
        var l = e[i](a), c = l.value;
    } catch (e) {
        return void n(e);
    }
    l.done ? o(c) : Promise.resolve(c).then(t, r);
}
function _asyncToGenerator(l) {
    return function () {
        var e = this, a = arguments;
        return new Promise(function (o, n) {
            var t = l.apply(e, a);
            function r(e) {
                asyncGeneratorStep(t, o, n, r, i, 'next', e);
            }
            function i(e) {
                asyncGeneratorStep(t, o, n, r, i, 'throw', e);
            }
            r(void 0);
        });
    };
}
var LOGINURL = '//user.ifeng.com/allsite/login';
exports.LOGINURL = LOGINURL;
var LOGINMOB = '//user.ifeng.com/allsite/loginmob', LOGOUTURL = '//id.ifeng.com/index.php/api/logout', CHECKLOGINURL = '//id.ifeng.com/api/checklogin', uuid = function () {
        return 'dialog_'.concat(Math.floor(Math.random() * Date.now()));
    };
exports.uuid = uuid;
var EVENTNAMES = {
    login: 'login',
    logout: 'logout',
    dialogOpen: 'dialogOpen',
    dialogClose: 'dialogClose',
    urlChange: 'urlChange'
};
exports.EVENTNAMES = EVENTNAMES;
var LOGINTIMER = null, REALTIMER = null, OTKTIMER = null, LOGOUTTIMER = null, event = 'undefined' != typeof window && window.WHALE_PC_AUTH_EVENT || new _base.Event();
exports.event = event, 'undefined' != typeof window && (window.WHALE_PC_AUTH_EVENT || (window.WHALE_PC_AUTH_EVENT = event));
var isReal = function () {
    return !(!_base.cookie.get('sid') || '0' !== _base.cookie.get('IF_REAL'));
};
exports.isReal = isReal;
var isLogin = function () {
    return !!_base.cookie.get('sid');
};
exports.isLogin = isLogin;
var getUserInfo = function () {
    return {
        sid: _base.cookie.get('sid'),
        userName: _base.cookie.get('IF_USER'),
        isReal: isReal()
    };
};
exports.getUserInfo = getUserInfo;
var checkLogin = function () {
        clearInterval(LOGINTIMER), LOGINTIMER = setInterval(function () {
            isLogin() && (event.trigger(EVENTNAMES.login, getUserInfo()), clearInterval(LOGINTIMER), _base.cookie.get('IF_OTK') || clearInterval(OTKTIMER));
        }, 300);
    }, checkReal = function () {
        clearInterval(REALTIMER), REALTIMER = setInterval(function () {
            isReal() ? (event.trigger(EVENTNAMES.dialogClose), clearInterval(REALTIMER)) : _base.cookie.get('sid') && event.trigger(EVENTNAMES.urlChange, LOGINMOB);
        }, 300);
    }, checkOTK = function () {
        _base.cookie.del('IF_OTK', '/', '.ifeng.com'), clearInterval(OTKTIMER), OTKTIMER = setInterval(function () {
            var e = _base.cookie.get('IF_OTK');
            if (e.trim()) {
                clearInterval(OTKTIMER);
                try {
                    var o = new Function('return '.concat(e))();
                    console.log(o), _base.cookie.del('IF_OTK', '/', '.ifeng.com'), 1 !== o.code && 'OK' !== o.code && (event.trigger(EVENTNAMES.urlChange, LOGINURL), alert(o.message || '第三方登录失败\uFF0C请刷新页面重试'));
                } catch (e) {
                    _base.cookie.del('IF_OTK', '/', '.ifeng.com'), alert('第三方登录失败\uFF0C请刷新页面重试');
                }
            }
        }, 300);
    }, login = function (e) {
        checkLogin(), checkOTK(), checkReal();
        var o = isLogin() && !isReal() ? LOGINMOB : LOGINURL;
        event.trigger(EVENTNAMES.dialogOpen, o, e);
    };
exports.login = login;
var closeDialog = function () {
    clearInterval(LOGINTIMER), clearInterval(REALTIMER), clearInterval(OTKTIMER), event.trigger(EVENTNAMES.dialogClose);
};
exports.closeDialog = closeDialog;
var logout = function () {
    _base.cookie.del('sid', '/', '.ifeng.com'), clearInterval(LOGOUTTIMER), LOGOUTTIMER = setInterval(function () {
        isLogin() || (clearInterval(LOGOUTTIMER), event.trigger(EVENTNAMES.logout), checkLogin());
    }, 300);
};
exports.logout = logout;
var remoteChecklogin = function () {
    var o = _asyncToGenerator(regeneratorRuntime.mark(function e(o) {
        var n;
        return regeneratorRuntime.wrap(function (e) {
            for (;;)
                switch (e.prev = e.next) {
                case 0:
                    return e.prev = 0, e.next = 3, (0, _base.jsonp)(CHECKLOGINURL, {
                        data: { sid: o },
                        jsonpCallback: '__checkloginCallback',
                        cache: !1
                    });
                case 3:
                    return n = e.sent, e.abrupt('return', 1 === n.code ? n.data : {});
                case 7:
                    return e.prev = 7, e.t0 = e.catch(0), e.abrupt('return', {});
                case 10:
                case 'end':
                    return e.stop();
                }
        }, e, null, [[0,7]]);
    }));
    return function (e) {
        return o.apply(this, arguments);
    };
}();
exports.remoteChecklogin = remoteChecklogin;